// Router Registration
export default [
  {
    path: '/oa/email_validation/:uid/:token',
    name: 'validateOA',
    component: () => import(/* webpackChunkName: "oa" */ '../../views/registration/oa/emailValidation/EmailValidation.vue'),
    beforeEnter: (to, from, next) => {
      if (process.env.VUE_APP_ENV === 'staging' || process.env.VUE_APP_ENV === 'prod') {
        next({ name: '404' });
      } else {
        next();
      }
    },
  },
  // {
  //   path: '/member/email_validation/:uid/:token',
  //   name: 'validateMember',
  //   component: () => import('./views/registration/member/emailValidation/EmailValidation.vue'),
  // },
  {
    path: '/member/email_validation/:uid/:token',
    name: 'userRegister',
    component: () => import(/* webpackChunkName: "individual" */ '../../views/registration/member/memberRegistration/CreateMember.vue'),
  },
  {
    path: '/individual/email_register',
    name: 'registerEmailIndividual',
    component: () => import(/* webpackChunkName: "individual" */ '../../views/registration/individual/emailRegistration/CreateIndividual.vue'),
    beforeEnter: (to, from, next) => {
      if (process.env.VUE_APP_ENV === 'staging' || process.env.VUE_APP_ENV === 'prod') {
        next({ name: '404' });
      } else {
        next();
      }
    },
  },
  {
    path: '/coach/confirm-your-registration',
    name: 'confirmYourRegistration',
    component: () => import(/* webpackChunkName: "coach" */ '../../views/registration/coach/CompleteRegistration.vue'),
  },
  // {
  //   path: '/individual/email_validation/:uid/:token',
  //   name: 'validateIndividual',
  //   component: () => import(
  //     /* webpackChunkName: "individual" */
  //     './views/registration/individual/emailValidation/EmailValidation.vue',
  //   ),
  //   beforeEnter: (to, from, next) => {
  //     if (process.env.VUE_APP_ENV === 'staging' || process.env.VUE_APP_ENV === 'prod') {
  //       next({ name: '404' });
  //     } else {
  //       next();
  //     }
  //   },
  // },
];
